import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Paper,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import { setVideoList } from "../../../Redux/Actions/PastSeasonActions";
import { FaPlusSquare } from "react-icons/fa";

const WeekList = ({
  active,
  setActive,
  expanded,
  setExpanded,
  setSelectedVideos,
}) => {
  const dispatch = useDispatch();
  const selectedEvent = useSelector(
    (state) => state.selectedSeasonData.selectedEventData
  );

  const handleWeekAccordionChange = (panel) => (event, isExpanded) => {
    if (isExpanded) {
      setActive(null);
    }
    setExpanded(isExpanded ? panel : false);
    setSelectedVideos([]);
  };
  return (
    <>
      {typeof selectedEvent === "object" &&
      Object.keys(selectedEvent).length &&
      selectedEvent[0]?.weekName ? (
        <Paper className="min-width-350">
          <h1 className="storage-title bold">Week's</h1>
          <div className="current-video">
            {Object.keys(selectedEvent).map((el, index) => (
              <div key={index} className="crnt-btn cp" id="event-btn">
                <Accordion
                  expanded={expanded?.weekName === selectedEvent[el].weekName}
                  className="event-box w-100"
                  onChange={handleWeekAccordionChange(selectedEvent[el])}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    className="subEventsSummary w-100"
                    sx={{ cursor: "pointer" }}
                  >
                    <Typography
                      sx={{
                        width: "100% !important",
                        flexShrink: 0,
                        cursor: "pointer",
                      }}
                      className="eventText w-100"
                    >
                      <div className="weekName-container">
                        <p className="text-width-auto">
                          {selectedEvent[el].weekName.replaceAll("-", " - ")}
                        </p>
                      </div>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div
                      className="crnt-btn cp"
                      id="event-btn"
                      onClick={() => {
                        setVideoList(dispatch, {
                          videoArr: selectedEvent[el]?.game,
                          eventType: "game",
                          weekName: selectedEvent[el].weekName,
                          weekIndex: index,
                        });
                        setActive(1);
                        setSelectedVideos([]);
                      }}
                    >
                      <Accordion
                        disableGutters
                        className={`event-box w-100 ${
                          active === 1 && expanded?.id === el.id && "active-btn"
                        }`}
                      >
                        <AccordionSummary
                          aria-controls="panel2bh-content"
                          id="panel2bh-header"
                          className="d-flex"
                        >
                          <Typography
                            sx={{
                              width: "100% !important",
                              flexShrink: 0,
                              cursor: "pointer",
                            }}
                          >
                            <div className="d-flex-align-cent">
                              <FaPlusSquare
                                className="mg-right-10"
                                style={{ color: "#13005A" }}
                              />
                              Game ({selectedEvent[el].game?.length})
                            </div>
                          </Typography>
                        </AccordionSummary>
                      </Accordion>
                    </div>

                    <div
                      className="crnt-btn cp"
                      id="event-btn"
                      onClick={() => {
                        setVideoList(dispatch, {
                          videoArr: selectedEvent[el]?.practice,
                          eventType: "practice",
                          weekName: selectedEvent[el].weekName,
                          weekIndex: index,
                        });
                        setActive(2);
                        setSelectedVideos([]);
                      }}
                    >
                      <Accordion
                        disableGutters
                        className={`event-box w-100 ${
                          active === 2 && expanded?.id === el.id && "active-btn"
                        }`}
                      >
                        <AccordionSummary
                          aria-controls="panel2bh-content"
                          id="panel2bh-header"
                          className="d-flex"
                        >
                          <Typography
                            sx={{
                              width: "100% !important",
                              flexShrink: 0,
                              cursor: "pointer",
                            }}
                          >
                            <div className="d-flex-align-cent cp">
                              <FaPlusSquare
                                className="mg-right-10"
                                style={{ color: "#13005A" }}
                              />
                              Practice (
                              {selectedEvent[el].practice
                                ? selectedEvent[el].practice.length
                                : 0}
                              )
                            </div>
                          </Typography>
                        </AccordionSummary>
                      </Accordion>
                    </div>

                    <div
                      className="crnt-btn cp"
                      id="event-btn"
                      onClick={() => {
                        setVideoList(dispatch, {
                          videoArr: selectedEvent[el]?.opponentScout,
                          eventType: "opponentScout",
                          weekName: selectedEvent[el].weekName,
                          weekIndex: index,
                        });
                        setActive(3);
                        setSelectedVideos([]);
                      }}
                    >
                      <Accordion
                        disableGutters
                        className={`event-box w-100 ${
                          active === 3 && expanded?.id === el.id && "active-btn"
                        }`}
                      >
                        <AccordionSummary
                          aria-controls="panel2bh-content"
                          id="panel2bh-header"
                          className="d-flex"
                        >
                          <Typography
                            sx={{
                              width: "100% !important",
                              flexShrink: 0,
                              cursor: "pointer",
                            }}
                          >
                            <div className="d-flex-align-cent">
                              <FaPlusSquare
                                className="mg-right-10"
                                style={{ color: "#13005A" }}
                              />
                              Opponent Scout (
                              {selectedEvent[el].opponentScout
                                ? selectedEvent[el].opponentScout.length
                                : 0}
                              )
                            </div>
                          </Typography>
                        </AccordionSummary>
                      </Accordion>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
            ))}
          </div>
        </Paper>
      ) : null}
    </>
  );
};

export default WeekList;
